import { GridRowModesModel, GridRenderCellParams } from '@mui/x-data-grid-pro';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { Stack } from '@mui/material';
import { CubeDefinitionRowItem } from 'types/api/SystemTenant/AROCube/CubeBuilderTypes';
import { ModalCubeAttributeDisplayNameProps } from './ModalCubeAttributeDisplayName';

interface CubeDefinitionActionDisplayNameBUttonProps extends GridRenderCellParams<CubeDefinitionRowItem> {
  setRowModesModel: (newModel: (oldModel: GridRowModesModel) => GridRowModesModel) => void;
  fieldName: 'displayName' | null;
  setModalAttributeDisplayName: (
    newState: (OldState: ModalCubeAttributeDisplayNameProps) => ModalCubeAttributeDisplayNameProps
  ) => void;
  disabled?: boolean;
}

export function CubeDefinitionActionDisplayNameButton(props: CubeDefinitionActionDisplayNameBUttonProps) {
  const { hasFocus, row, setModalAttributeDisplayName: setModalParameterState, fieldName, disabled = false } = props;

  if (!fieldName || row?.isNew) return <span></span>;

  const handleOnClick = () => {
    if (fieldName) {
      setModalParameterState((prevState) => ({ ...prevState, visible: true, cubeDefinitionItem: row, fieldName }));
    }
  };

  if (row[fieldName]) {
    return (
      <Stack direction='row' alignItems='center'>
        <IconButton onClick={handleOnClick} aria-label='delete' size='small' disabled={disabled}>
          <ModeEditOutlineOutlinedIcon fontSize='inherit' />
        </IconButton>
        <div>{row[fieldName]}</div>
      </Stack>
    );
  }

  return (
    <Button
      variant='secondary-table-panel'
      sx={{
        height: '58%',
        fontSize: '12px',
      }}
      onClick={handleOnClick}
      tabIndex={hasFocus ? 0 : -1}
      disabled={disabled}
      onKeyDown={(event: React.KeyboardEvent) => {
        if (event.key === ' ') {
          event.stopPropagation();
        }
      }}
    >
      {row[fieldName] ? 'View' : 'Create'}
    </Button>
  );
}
